import $ from "jquery";
import * as L from "leaflet";
import "leaflet.markercluster";

$(document).ready(function () {
    // deklarera
    let markersArray = [];
    let map;
    let address;
    let latitude;
    let Longtitude;
    let coordinates = [];

    $(".vgr-toggle-content__item__link").click(function (e) {
        let searchItem = $(e.target.closest(".vgr-toggle-content__list"));

        // tömma markerarray
        markersArray.length = 0;
        coordinates.length = 0;

        let token = "fb3c80432560905ae9be32acbc5bc065";

        // loopa igenom address lista för varje item
        for (let c = 0; c < searchItem.length; c++) {
            let id = searchItem[c].getAttribute("data-id");

            let VisitingAdress = $(searchItem[c]).children(".visiting-adress");

            address = VisitingAdress[c].getAttribute("data-address");
            latitude = VisitingAdress[c].getAttribute("data-latitude");
            Longtitude = VisitingAdress[c].getAttribute("data-Longtitude");

            // pusha en address till en array

            coordinates.push({ lat: latitude, lon: Longtitude, adress: address });

            let crs = new L.Proj.CRS(
                "EPSG:3006",
                "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
                {
                    resolutions: [4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8],
                    origin: [-1200000.0, 8500000.0],
                    bounds: L.bounds([-1200000.0, 8500000.0], [4305696.0, 2994304.0]),
                }
            ),

            // Initialisera leaflet map
            map = new L.Map("map" + " " + id, {
                crs: crs,
                continuousWorld: true,
            });

            // addera layer för mapen
            L.tileLayer(
                "https://api.lantmateriet.se/open/topowebb-ccby/v1/wmts/token/" +
                token +
                "/?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=topowebb&STYLE=default&TILEMATRIXSET=3006&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image%2Fpng",
                {
                    attribution:
                        '&copy; <a href="http://www.lantmateriet.se/en/">Lantmäteriet</a> Topografisk Webbkarta Visning, CCB',
                    maxZoom: 9,
                    minZoom: 0,
                    continuousWorld: true,
                }
            ).addTo(map);

            let marker;
            let markers = L.markerClusterGroup();

            // loopa igenom arrayen
            for (let i = 0; i < coordinates.length; i++) {
                if (coordinates[i] != undefined) {
                    // ta fram markers med hjälp av lat och lon
                    marker = new L.marker([coordinates[i].lat, coordinates[i].lon]);
                    // Koppla en popup ruta som visar adress
                    marker.bindPopup(GetInfoWindowHtml(coordinates[i]));

                    markers.addLayer(marker);
                    markersArray.push(marker);
                }
            }

            map.addLayer(markers);

            let group = new L.featureGroup(markersArray);

            map.fitBounds(group.getBounds());
        }
    });

    function GetInfoWindowHtml(clinic) {
        let html = '<div class="vgr-search-list-infowindow">';
        if (clinic.adress != null) {
            html += "<div>";
            html +=
                '<span class="vgr-search-list-infowindow__text vgr-search-list-infowindow__text--label" >Adress: </span>';
            html +=
                '<span class="vgr-search-list-infowindow__text">' +
                clinic.adress +
                "</span>";
            html += "</div>";
        }

        return html;
    }   
});
